import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@/components/buttons/Button';
import { useLogin } from '@/hooks/useLogin';
import { OpenedFrom } from '@/lib/gTagManager';
import { LoginFlowVariant } from '@/store/authentication/AuthenticationStore';

const ForgotPasswordSmsSuccess = () => {
  const intl = useIntl();
  const { openLogin } = useLogin();

  const onLoginClicked = () => {
    openLogin({
      openedFrom: OpenedFrom.ForgotPasswordSmsSuccess,
      variant: LoginFlowVariant.Mobile,
    });
  };

  return (
    <>
      <p className="mb-6 leading-snug text-white text-justify">
        {intl.formatMessage({ id: 'authentication.forgot-password-success.sms.description' })}
      </p>
      <Button
        onClickHandler={onLoginClicked}
        text={intl.formatMessage({ id: 'authentication.forgot-password-success.button' })}
        type="button"
        btnType="primary"
        data-cy="forgot-password-success-button"
      />
    </>
  );
};

export default ForgotPasswordSmsSuccess;
